import { FC } from 'react';

interface Props {
  position: { top: string | null; right: string | null; left: string | null };
}

const EphemeralMessageStrokeBottom: FC<Props> = ({ position }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="38"
      viewBox="0 0 31 38"
      fill="none"
      style={{
        position: 'absolute',
        top: `${position?.top}`,
        right: `${position?.right ? position?.right : ''}`,
        left: `${position?.left ? position?.left : ''}`,
        zIndex: '6',
      }}
    >
      <path
        d="M28.5215 30.1855C28.5212 31.7928 26.6091 32.889 25.1445 31.9404C21.579 29.631 16.9617 26.8074 12.4746 24.5537C10.2314 23.427 7.98801 22.426 5.90235 21.7031C4.57291 21.2423 3.2527 20.8763 2.00293 20.6738C2.00301 20.6416 2.00283 20.6094 2.00293 20.5771C13.542 20.7769 20.2377 16.524 24.0186 11.8145C25.9819 9.36891 27.0975 6.87824 27.7236 5C27.909 4.44398 28.0508 3.93809 28.1611 3.5L28.5215 3.5L28.5215 30.1855Z"
        fill="#FEFBF9"
        stroke="#F1F0EE"
        strokeWidth="4"
      />
      <path d="M4.02148 0H26.5215V30L4.02148 18V0Z" fill="#FEFBF9" />
    </svg>
  );
};

export default EphemeralMessageStrokeBottom;
